// eslint-disable-next-line import/prefer-default-export
export const AuthState = {
  Unknown: 'Unknown',
  Requesting: 'Requesting',
  Authorised: 'Authorised',
  Unauthorised: 'Unauthorised',
  LoggedOut: 'LoggedOut'
};
